import React from 'react'
import { ServicePage, Title, Desc, Actions, Image } from '../../components/service-page'
import { ReactComponent as Error } from './images/error.svg'

const title = 'Oh no! Something went wrong'
const desc = [
  'We keep track of these errors, but feel free to contact us if',
  "refreshing doesn't fix things."
]

const ErrorPage = props => {
  return (
    <ServicePage maxContentWidth={1440} inset={3}>
      <Title>{title}</Title>
      <Desc text={desc} />
      <Image imageComponent={Error} />
      <Actions />
    </ServicePage>
  )
}

export default ErrorPage
